module.exports = __webpack_public_path__ + "img/AICM项目5大成果.34c7c022.png";